import type { FontConfig } from "@/domains/design/types"
import type { DeepPartial } from "@/domains/library"
import type { ResponsiveMode } from "@/hooks/use-responsive"
import { useFontConfig } from "@/domains/design/hooks/use-font-config"
import { BODY_CAPTION_CONFIG } from "@/domains/design/system/body-caption"
import { cn } from "@/domains/library"

export const BodyCaption = ({
  children,
  className,
  options,
  mode,
  As = "span",
}: {
  children?: React.ReactNode
  className?: string
  options?: DeepPartial<FontConfig>
  mode?: ResponsiveMode
  As?: React.ElementType
}) => {
  const config = useFontConfig({ baseConfig: BODY_CAPTION_CONFIG, options, mode })

  if (!config) {
    return null
  }

  return (
    <As
      className={cn(config.family.tw, config.weight.tw, config.size.tw, config.lineHeight.tw, "text-t100", className)}
    >
      {children}
    </As>
  )
}
